import React from 'react';
import PageLayout from '@/components/layout/PageLayout';
import { Wizard } from '@/components/ui/navigation/Wizard';
import { useCompanyCreate } from '@/hooks/company/useCompanyCreate';
import { CreateCompanyInfoForm } from '@/components/features/company/CreateCompanyInfoForm';
import { CreateCompanyConfigForm } from '@/components/features/company/CreateCompanyConfigForm';


export const CompanyCreate: React.FC = () => {
  const {
    isLoading,
    setActiveTab,
    currentStepIndex,
    completedSteps,
    handleCancel,
    handleCreate,
    handleCopySeedAssistance,
    regionOptions,
    communeOptions,
    holdingCompanyOptions,
    creating,
    isParentCompanyLocked,
    infoForm,
    configForm,
    handleNext,
    handlePrevious,
    logoHook,
  } = useCompanyCreate();

  const steps = [
    {
      id: 'info',
      label: 'Información Empresa',
      content: (
        <CreateCompanyInfoForm
          infoForm={infoForm}
          regionOptions={regionOptions}
          communeOptions={communeOptions}
          onCancel={handleCancel}
          onNext={handleNext}
        />
      ),
    },
    {
      id: 'config',
      label: 'Configuración',
      content: (
        <CreateCompanyConfigForm
          configForm={configForm}
          holdingCompanyOptions={holdingCompanyOptions}
          onCancel={handleCancel}
          onCreate={handleCreate}
          creating={creating}
          isParentCompanyLocked={isParentCompanyLocked}
          onPrevious={handlePrevious}
          logoHook={logoHook}
          onCopySeedAssistance={handleCopySeedAssistance}
        />
      ),
    },
  ];

  return (
    <PageLayout isLoading={isLoading}>
      <div className="flex flex-col gap-6" data-testid="company-create-page">
        <Wizard
          steps={steps}
          currentStep={currentStepIndex}
          completedSteps={completedSteps}
          onStepChange={(stepIndex) => {
            const indexToTab: Record<number, 'info' | 'config'> = {
              0: 'info',
              1: 'config',
            };
            setActiveTab(indexToTab[stepIndex]);
          }}
        />
      </div>
    </PageLayout>
  );
};

export default CompanyCreate;
